export default __webpack_public_path__ + "css/supplierCreditNote.bundle.css";